import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { CreatePrivilegeComponent } from '../../role-management/create-privilege/create-privilege.component';
import { Router } from '@angular/router';
import { AdminDetailsModalComponent } from '../admin-details-modal/admin-details-modal.component';
import { CreateAdminComponent } from '../create-admin/create-admin.component';
import { ModalService } from 'src/app/services/modal-service/modal.service';

@Component({
  selector: 'app-admin-management-landing',
  standalone: false,
  templateUrl: './admin-management-landing.component.html',
  styleUrl: './admin-management-landing.component.scss'
})
export class AdminManagementLandingComponent {
  action_idx: any = null;

  dataList: any[] = [];
  form: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;

  @Output() onConfirmClicked = new EventEmitter();

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {

    this.form = this.fb.group({
      name: [''],
      status: [''],
      createdBy: [''],
      email: [''],
      phoneNumber: [''],
      from: [''],
      to: [''],
      offset: [''],
    });
    this.search();
  }

  clearSearchFilters() {
    this.form.reset()
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openDeactivateConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Deactivate admin: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deactivateAdmin(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  openActivateConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Activate Admin: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.activateAdmin(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  openDeleteConfirmModal(id: number, name: string) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Delete sadmin: ' + name + '?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deleteAdmin(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  deleteAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/delete/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin deleted successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  deactivateAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/deactivate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin deactivated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  activateAdmin(id: number): void {
    this.isLoading = true;
    this.apiService
      .get(`/auth/user/activate/${id}`)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal('Admin activated successfuly');
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();
  }

  errorFetchingData: boolean = false;


  search() {
    this.dataList = [];
    this.searchedDataNotFound = false;
    this.isSearching = true;
    this.errorFetchingData = false;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);
    formData.append('name', this.form.get('name')?.value || '');
    formData.append('email', this.form.get('email')?.value || '');
    formData.append('phoneNumber', this.form.get('phoneNumber')?.value || '');
    formData.append("createdBy", this.form.get('createdBy')?.value || '');
    formData.append("status", this.form.get('status')?.value || '');
    formData.append("from", this.form.get('from')?.value || '');
    formData.append("to", this.form.get('to')?.value || '');

    this.apiService
      .post('/auth/admin/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data;

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }

  splitPriviledges(privileges: String): string[] {
    return privileges?.split(',').map((item) => item.trim());
  }

  openDialogRef(data?: any) {
    let dialogRef = this.dialog.open(CreateAdminComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      disableClose: true,

      data,
    });

    return dialogRef;
  }

  createAdmin() {
    this.router.navigate(['admin/admin-management/create']);
  }

  viewAdmin(data: any) {
    let dialog = this.dialog.open(AdminDetailsModalComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-lg',],
      disableClose: true,

      data,
    })
  }

  isUnlockingAccount: boolean;
  unlockUserAccount(userId: number) {
    this.isUnlockingAccount = true;
    return this.apiService.get(`/auth/user/unlock-account/${userId}`).subscribe((res: any) => {
      if (res.success) {
        res.message && this.modalService.openSuccessModal(res.message).afterClosed().subscribe((data: any) => {
          this.search()
        })
      }

      else {
        this.modalService.openErrorModal(res.message)
      }

      this.isUnlockingAccount = false;

    },
      (error) => {
        this.modalService.openErrorModal(error.message);
        this.isUnlockingAccount = false;
      })
  }

  updateAdmin(data: any) {
    let dialog = this.dialog.open(AdminDetailsModalComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-lg', 'scrollable-modal'],
      disableClose: true,

      data: { ...data, isInEditingMode: true },
    })
  }

  edit(admin: any) {
    // let dialogRef = this.openDialogRef({
    //   ...privilege,
    // });

    // dialogRef.afterClosed().subscribe(() => {
    //   this.search()
    // });
    console.warn('in progress');
  }
}
